import Vue from 'vue';
import feathersClient from '../../feathers-client';

export default {
	state: {
		jobTitles: [],
		spinePoints: [],
		modeOfCommutes: [],
		bandTypes: [],
		careSpecialities: [],
		roleTypes: [],
		trusts: [],
		skills: [],
		trustCareSpecilities: [],
		trustCareLocations: [],
	},
	getters: {
		jobTitles: (state) => state.jobTitles,
		careSpecialities: (state) => state.careSpecialities,
		roleTypes: (state) => state.roleTypes,
		skills: (state) => state.skills,
		trustCareSpecilities: (state) => state.trustCareSpecilities,
		trustCareLocations: (state) => state.trustCareLocations,
	},
	mutations: {
		SET_JOB_TITLES: (state, jobTitles) => {
			state.jobTitles = jobTitles;
		},
		SET_BANDS: (state, bands) => {
			state.bandTypes = bands;
		},
		SET_SPINE_POINTS: (state, spinePoints) => {
			state.spinePoints = spinePoints;
		},
		SET_MODE_OF_COMMUTES: (state, modeOfCommutes) => {
			state.modeOfCommutes = modeOfCommutes;
		},
		SET_CARE_SPECIALITY_TYPES: (state, careSpecialities) => {
			state.careSpecialities = careSpecialities;
		},
		SET_SKILLS: (state, skills) => {
			state.skills = skills;
		},
		SET_ROLE_TYPES: (state, roleTypes) => {
			state.roleTypes = roleTypes;
		},
		SET_TRUSTS: (state, trusts) => { state.trusts = trusts; },
		SET_TRUST_CARE_LOCATIONS: (state, data) => { state.trustCareLoactions = data; },
		SET_TRUSTS_CARE_SPECIALITY_TYPES: (state, data) => {
			state.trustCareSpecilities = data;
		},
	},
	actions: {
		loadRoleTypes: async ({ commit }) => {
			const url = '/api/v3/user-role-types';
			const results = await feathersClient.service(url).find({ query: { name: { $nin: ['SUPER-ADMIN'] } } });
			commit('SET_ROLE_TYPES', results);
			return results;
		},
		loadJobTitles: async ({ commit }, query) => {
			const results = await feathersClient.service('api/v3/job-title-types').find({
				query: {
					...query,
					$paginate: false,
				},
			});
			commit('SET_JOB_TITLES', results);
			return results;
		},
		createJobTitle: async ({ rootGetters }, jobTitle) => {
			const url = '/api/v3/job-title-types';
			const results = await feathersClient.service(url).create(jobTitle, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateJobTitle: async ({ rootGetters }, jobTitle) => {
			const url = '/api/v3/job-title-types';
			const results = await feathersClient.service(url).patch(jobTitle.id, jobTitle, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteJobTitle: async ({ rootGetters }, jobTitleId) => {
			const url = `/api/v3/job-title-types/`;
			const results = await feathersClient.service(url).remove(jobTitleId, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadBandTypes: async ({ commit }, filter) => {
			const results = await feathersClient.service('/api/v3/band-types').find({
				query: {
					$sort: { number: 1 },
					$paginate: false,
					fields: ['spinePoints'],
					...filter,
				},
			});
			commit('SET_BANDS', results);
			return results;
		},
		createBandType: async ({ rootGetters }, band) => {
			const url = '/api/v3/band-types';
			const results = await feathersClient.service(url).create(band, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateBandType: async ({ rootGetters }, band) => {
			const url = '/api/v3/band-types';
			const results = await feathersClient.service(url).patch(band.id, band, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteBandType: async ({ rootGetters }, bandId) => {
			const url = `/api/v3/band-types/`;
			const results = await feathersClient.service(url).remove(bandId, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadModeOfCommutes: async ({ commit }) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).find({});
			commit('SET_MODE_OF_COMMUTES', results);
			return results.data;
		},
		createModeOfCommute: async ({ rootGetters }, modeOfCommute) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).create(modeOfCommute, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateModeOfCommute: async ({ rootGetters }, modeOfCommute) => {
			const url = `/api/v3/modeofcommute/${modeOfCommute.id}`;
			const results = await feathersClient.service(url).patch(modeOfCommute.id, modeOfCommute, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteModeOfCommute: async ({ rootGetters }, modeOfCommuteId) => {
			const url = `/api/v3/modeofcommute/${modeOfCommuteId}`;
			const results = await feathersClient.service(url).remove(modeOfCommuteId, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadCareSpecialities: async ({ commit }) => {
			const results = await feathersClient.service('/api/v3/care-speciality-types').find({});
			commit('SET_CARE_SPECIALITY_TYPES', results);
			return results;
		},
		loadSkills: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/skills').find({
				query: {
					$role: rootGetters.currentUserRole,
					$sort: { number: 1 },
					$limit: false,
					...filter,

				},
			});
			commit('SET_SKILLS', results.data);
			return results.data;
		},
		loadTrusts: async({ commit, rootGetters }) => {
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).find({
				query: {
					$paginate: false,
				},
			});
			commit('SET_TRUSTS', results);
			return results;
		},
		loadTrustCareLocation: async({ commit, rootGetters }) => {
			const url = '/api/v3/care-locations';
			const result = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
				},
			});
			commit('SET_TRUST_CARE_LOCATIONS', result);
		},
		loadTrustCareSpecialitiesTypes: async({commit, rootGetters}) => {
				let isLiveResult = []
				const result = await feathersClient.service('/api/v3/trust-care-specialities').find({
					query: {
						$role: rootGetters.currentUserRole,
						$paginate: false,
						fields: ['careSpecialityType'],
						isLive: true,
					},
				});
				isLiveResult = result.map(item => {
					return item.careSpecialityType
				})
				commit('SET_TRUSTS_CARE_SPECIALITY_TYPES',isLiveResult)
				return result

		},
		getChatGptResult: async({ commit }, data) => {
			const result = await feathersClient.service('/api/v3/ask-to-chat-gpt').create(data);
			return result.result;
		},
		getShiftConfiguration: async function({ rootGetters }, id) {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query: {
					$role:rootGetters.currentUserRole,
					$getShiftConfiguration: true,
				},
			});
			return results;
		},
		updateOptimaTrustRoleTypeMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').create(data, {
				query: {
					$updateShiftConfiguration: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
	},
};
